module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-check-c588d864d9f80e51c3e9d4cce3beddc8.svg";